import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import { createAccount, deposit, withdraw } from '../store/slices/accountSlice';

function AccountManagement() {
  const dispatch = useDispatch();
  const [amount, setAmount] = useState('');
  const { balance } = useSelector((state) => state.account);

  const handleCreateAccount = () => {
    dispatch(createAccount());
  };

  const handleDeposit = () => {
    dispatch(deposit(Number(amount)));
    setAmount('');
  };

  const handleWithdraw = () => {
    dispatch(withdraw(Number(amount)));
    setAmount('');
  };

  return (
    <div>
      <h2>Account Management</h2>
      <Button variant='primary' onClick={handleCreateAccount}>Create Account</Button>
      <Form className='mt-3'>
        <Form.Group controlId='formAmount'>
          <Form.Label>Amount</Form.Label>
          <Form.Control
            type='number'
            placeholder='Enter amount'
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </Form.Group>
        <Button variant='success' className='mr-2' onClick={handleDeposit}>Deposit</Button>
        <Button variant='danger' onClick={handleWithdraw}>Withdraw</Button>
      </Form>
      <h3 className='mt-3'>Current Balance: ${balance}</h3>
    </div>
  );
}

export default AccountManagement;
